<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.rents') }}
        </div>
      </template>

      <div class="row align--center mt-1">
        <div class="flex xs12 sm3 md2">
          <va-input
            v-model="filter.code"
            :label="$t('tables.searchBy.rentCode')"
          />
        </div>
        <div class="flex xs10 sm12 md3">
          <va-select
            v-model="filter.status"
            :label="$t('tables.searchBy.status')"
            textBy="label"
            keyBy="key"
            :options="statusOptions"
          />
        </div>
        <div class="flex xs12 sm3 md1" v-show="!!filter.user_id">
          <va-input
            v-model="filter.user_id"
            :label="$t('tables.searchBy.userId')"
          />
        </div>
        <div class="flex xs12 sm6 md2" :class="!!filter.user_id ? 'sm2 md1' : 'sm3 md2'">
          <va-input
            v-model="filter.user_fullname"
            :label="$t('tables.searchBy.user')"
          />
        </div>
                <div class="flex xs12 sm6 md2">
          <div class="div--relative">
            <va-date-picker
              v-model="filter.pickup_time"
              :label="$t('tables.searchBy.pickupDate')"
              :config="{dateFormat: 'd.m.Y'}"
            />
            <va-button v-show="!!filter.pickup_time" small flat @click.stop="clearDatePicker('pickup_time')" icon="fa fa-times-circle" slot="append" class="btn--clear" color="gray"/>
          </div>
          <div class="div--relative">
            <va-date-picker
              v-model="filter.pickup_time_range"
              :config="{dateFormat: 'd.m.Y'}"
            />
            <va-button v-show="!!filter.pickup_time_range" small flat @click.stop="clearDatePicker('pickup_time_range')" icon="fa fa-times-circle" slot="append" class="btn--clear" color="gray"/>
          </div>
        </div>
        <div class="flex xs12 sm6 md2">
          <div class="div--relative">
            <va-date-picker
              v-model="filter.dropoff_time"
              :label="$t('tables.searchBy.dropoffDate')"
              :config="{dateFormat: 'd.m.Y'}"
            />
            <va-button v-show="!!filter.dropoff_time" small flat @click.stop="clearDatePicker('dropoff_time')" icon="fa fa-times-circle" slot="append" class="btn--clear" color="gray"/>
          </div>
          <div class="div--relative">
            <va-date-picker
              v-model="filter.dropoff_time_range"
              :config="{dateFormat: 'd.m.Y'}"
            />
            <va-button v-show="!!filter.dropoff_time_range" small flat @click.stop="clearDatePicker('dropoff_time_range')" icon="fa fa-times-circle" slot="append" class="btn--clear" color="gray"/>
          </div>
        </div>
        <div class="flex xs3 sm2 md1">
          <div class="btn--wrapper">
            <va-button small outline @click.stop="onfilter" icon="fa fa-search"/>
            <va-button v-show="hasFilter" small outline @click.stop="onclearfilter" icon="fa fa-eraser"/>
          </div>
        </div>
      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
        @row-clicked="show"
      >
        <template slot="pickup_time_readable" slot-scope="props">
          {{ timeReadableToString(props.rowData.pickup_time_readable) }}
        </template>

        <template slot="dropoff_time_readable" slot-scope="props">
          {{ timeReadableToString(props.rowData.dropoff_time_readable) }}
        </template>

        <template slot="vehicle" slot-scope="props">
          <va-popover :message="props.rowData.vehicle ? props.rowData.vehicle.name_readable : ''" placement="bottom" color="dark">
            <va-avatar v-if="props.rowData.vehicle && props.rowData.vehicle.images_readable.length > 0">
              <img :src="props.rowData.vehicle.images_readable[0]"/>
            </va-avatar>
            <va-avatar v-else>
              <va-icon name="fa fa-car" class="mx-auto my-auto"/>
            </va-avatar>
          </va-popover>
        </template>
        
        <template slot="status" slot-scope="props">
          <va-badge :color="getStatusColor(props.rowData.status)">
            {{ getStatusReadable(props.rowData.status) }}
          </va-badge>
        </template>

        <template slot="actions" slot-scope="props">
          <va-popover v-if="props.rowData.status==='waiting'" :message="`${$t('tables.actions.approve')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="info" icon="fa fa-check-square-o" @click.stop="confirmUpdateRent(props.rowData, 'approved')"/>
          </va-popover>
          <va-popover v-if="props.rowData.status!=='canceled'" :message="`${$t('tables.actions.cancel')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="warning" icon="fa fa-close" @click.stop="confirmUpdateRent(props.rowData, 'canceled')"/>
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-pagination
      v-model="pages.current_page"
      :visible-pages="3"
      :pages="pages.last_page"
      class="mt-3"
      :small="true"
      color="secondary"
    />
  </div>
</template>

<script>
import moment from "moment"
import rentServices from '../../services/api/rent'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
      filter: {
        code: null,
        user_id: null,
        user_fullname: null,
        pickup_time: null,
        pickup_time_range: null,
        dropoff_time: null,
        dropoff_time_range: null,
        status: ''
      },
      hasFilter: false,
      pages: {
        current_page: 1,
        last_page: 1
      },
      statusOptions : [{
          key: 'waiting',
          label: 'Onay Bekliyor'
        }, { 
          key: 'approved',
          label: 'Onaylandı'
        },{ 
          key: 'canceled',
          label: 'İptal Edildi'
        }
      ]
    }
  },
  computed: {
    fields () {
      return [{
        name: 'code',
        title: this.$t('tables.headings.rent.code'),
        dataClass: 'text-center',
      }, {
        name: '__slot:status',
        title: this.$t('tables.headings.rent.status'),
        width: '20%',
      }, {
        name: 'user.fullname',
        title: this.$t('tables.headings.rent.user'),
        width: '20%',
      }, {
        name: 'pickup_region.name_readable',
        title: this.$t('tables.headings.rent.pickupRegion'),
      }, {
        name: '__slot:pickup_time_readable',
        title: this.$t('tables.headings.rent.pickupDateTime'),
        width: '10%',
      }, {
        name: 'dropoff_region.name_readable',
        title: this.$t('tables.headings.rent.dropoffRegion'),
      }, {
        name: '__slot:dropoff_time_readable',
        title: this.$t('tables.headings.rent.dropoffDateTime'),
        width: '10%',
      }, {
        name: '__slot:vehicle',
        title: this.$t('tables.headings.rent.vehicle'),
        dataClass: 'text-center size-small',
      }, {
        name: '__slot:actions',
        width: '20%',
        dataClass: 'text-right',
      }]
    },
  },
  watch: {
    'pages.current_page': function(val) {
      let q = this.mergeQuery(q);
      q.sayfa = val;
      this.$router.push({ path: '/rezervasyon/listesi', query: q });
      this.getRents(val, JSON.parse(JSON.stringify(this.filter)));
    },
    '$route.query'(val) {
      this.splitQuery(val);
    }
  },
  methods: {
    async getRents(page=1, filter = {}){
      this.loading = true;
      this.hasFilter = !!this.filter.code || !!this.filter.user_id || !!this.filter.user_fullname || !!this.filter.pickup_time || !!this.filter.pickup_time_range || this.filter.dropoff_time || !!this.filter.dropoff_time_range || (!!this.filter.status && this.filter.status != '');

      filter.include = 'user,vehicle';
      filter.page = page;
      filter.limit = 15;
      if(!!filter.pickup_time) {
        if(!!filter['pickup_time_range']) {
          filter['pickup_time'] = '>' + filter['pickup_time'];
          filter['pickup_time_range'] = '<' + filter['pickup_time_range'];
          filter = await this.setTimeFilter (filter, 'pickup_time', 'pickup_time_range');
        }
        filter = await this.setTimeFilter (filter, 'pickup_time', 'pickup_time');
      }
      if(!!filter.dropoff_time) {
        if(!!filter['dropoff_time_range']) {
          filter['dropoff_time'] = '>' + filter['dropoff_time'];
          filter['dropoff_time_range'] = '<' + filter['dropoff_time_range'];
          filter = await this.setTimeFilter (filter, 'dropoff_time', 'dropoff_time_range');
        }
        filter = await this.setTimeFilter (filter, 'dropoff_time', 'dropoff_time');
      }
      if(!!filter.status && !!filter.status.key) {
        let status = filter.status.key,
            statusSign = String(status).charAt(0);
        if(statusSign === '!') {
          status = status.substr(1);
          delete filter.status;
          filter['status'+statusSign] = status;
        }
        else {
          filter.status = status;
        }
      }
      else {
        delete filter.status;
      }
      const result = await rentServices.get('?'+this.serialize(filter));
      if(result.error){
        this.items = [];
        return ;
      }
      this.loading = false;
      this.items = result.data.data;
      this.pages = result.data.meta;
    },
    getStatusColor (status) {
      if (status === 'approved') {
        return 'success'
      }
      if (status === 'canceled') {
        return 'danger'
      }
      return 'warning'
    },
    getStatusReadable (status) {
      if (status === 'approved') {
        return 'Onaylandı'
      }
      if (status === 'canceled') {
        return 'İptal Edildi'
      }
      return 'Onay Bekliyor'
    },
    setTimeFilter (filter, filterTimeLabel, filterTimeKey) {
      let fTime = JSON.parse(JSON.stringify(filter[filterTimeKey])),
          fTimeSign = String(filter[filterTimeKey]).charAt(0);
      if(fTimeSign === '<' || fTimeSign === '>') {
        fTime = String(fTime).substr(1);
        delete filter[filterTimeKey];
        filter[filterTimeLabel+fTimeSign] = moment(String(fTime), 'DD.MM.YYYY').format("YYYY-MM-DD");
      } else {
        filter[filterTimeLabel] = moment(String(fTime), 'DD.MM.YYYY').format("YYYY-MM-DD");
        filter[filterTimeLabel] += '*';
      }
      return filter;
    },
    timeReadableToString (data) {
      return data.date + ' ' + data.time;
    },
    async updateRent(id, status) {
      const res = await rentServices.put(id, {
        data: {
          status: status
        }
      });
      if(res.error){
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
      this.getRents(this.pages.current_page, JSON.parse(JSON.stringify(this.filter)));
    },
    confirmUpdateRent(item, status) {
      let statusReadable = this.getStatusReadable(status);
      this.$dialog
        .confirm( item.code + ' kodlu rezervasyonun durumunu ' + statusReadable + ' olarak değiştirmek üzeresiniz, onaylıyor musunuz?', {
          loader: true,
          okText: "Onayla",
          cancelText: "Vazgeç"
        })
        .then(dialog => {
          this.updateRent(item.id, status);
          dialog.close();
        })
        .catch(dialog => {
          dialog.close();
        });
    },
    onfilter () {
      let q = this.mergeQuery();
      q.sayfa = 1;
      this.$router.push({ path: '/rezervasyon/listesi', query: q });
      this.getRents(1, JSON.parse(JSON.stringify(this.filter)));
    },
    onclearfilter () {
      this.$router.push({ path: '/rezervasyon/listesi' });
      this.filter = { code: null, user_id: null, user_fullname: null, pickup_time: null, dropoff_time: null, status: '' };
      this.getRents(1, {});
    },
    clearDatePicker(selected) {
      if(selected === 'pickup_time'){
        this.filter.pickup_time = null;
      }
      else if(selected === 'dropoff_time'){
        this.filter.dropoff_time = null;
      }
    },
    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p) && obj[p] != null) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    mergeQuery() {
      let q = {};
      if(!!this.filter.code) {
        q.kod = this.filter.code!="" ? this.filter.code : null;
      } else {
        this.filter.code = this.filter.code!="" ? this.filter.code : null;
      }
      if(!!this.filter.user_fullname) {
        q.uye = this.filter.user_fullname!="" ? this.filter.user_fullname : null;
      } else {
        this.filter.user_fullname = this.filter.user_fullname!="" ? this.filter.user_fullname : null;
      }
      if(!!this.filter.user_id) {
        q.uye_no = this.filter.user_id!="" ? this.filter.user_id : null;
      } else {
        this.filter.user_id = this.filter.user_id!="" ? this.filter.user_id : null;
      }
      if(!!this.filter.pickup_time) {
        q.alim = this.filter.pickup_time!="" ? this.filter.pickup_time : null;
      } else {
        this.filter.pickup_time = this.filter.pickup_time!="" ? this.filter.pickup_time : null;
      }
      if(!!this.filter.pickup_time_range) {
        q.alim_aralik = this.filter.pickup_time_range!="" ? this.filter.pickup_time_range : null;
      } else {
        this.filter.pickup_time_range = this.filter.pickup_time_range!="" ? this.filter.pickup_time_range : null;
      }
      if(!!this.filter.dropoff_time) {
        q.teslim = this.filter.dropoff_time!="" ? this.filter.dropoff_time : null;
      } else {
        this.filter.dropoff_time = this.filter.dropoff_time!="" ? this.filter.dropoff_time : null;
      }
      if(!!this.filter.dropoff_time_range) {
        q.teslim_aralik = this.filter.dropoff_time_range!="" ? this.filter.dropoff_time_range : null;
      } else {
        this.filter.dropoff_time_range = this.filter.dropoff_time_range!="" ? this.filter.dropoff_time_range : null;
      }
      if(!!this.filter.status) {
        q.durum = this.filter.status!="" ? this.filter.status.key : null;
      }
      return q;
    },
    splitQuery(q) {
      let page = 1;
      if(q.sayfa) {
        page = parseInt(q.sayfa);
        delete q.sayfa;
      }
      if(q !== {}) {
        if(!!q.kod) {
          this.filter.code = q.kod;
        }
        if(!!q.uye) {
          this.filter.user_fullname = q.uye;
        }
        if(!!q.uye_no) {
          this.filter.user_id = q.uye_no;
        }
        if(!!q.alim) {
          this.filter.pickup_time = q.alim;
        }
        if(!!q.alim_aralik) {
          this.filter.pickup_time_range = q.alim_aralik;
        }
        if(!!q.teslim) {
          this.filter.dropoff_time = q.teslim;
        }
        if(!!q.teslim_aralik) {
          this.filter.dropoff_time_range = q.teslim_aralik;
        }
        if(!!q.durum) {
          this.filter.status = {};
          let status = q.durum,
            statusSign = String(status).charAt(0);
            if(statusSign === '!') {
              this.filter.status.key = q.durum;
              status = status.substr(1);
              this.filter.status.label = this.statusOptions.find(x => x.key === status).label + ' Hariç';
            }
            else {
              this.filter.status.key = q.durum;
              this.filter.status.label = this.statusOptions.find(x => x.key === q.durum).label;
            }
        }
      }
      this.getRents(page, JSON.parse(JSON.stringify(this.filter)));
    },
    show(item) {
      this.redirectTo('/rezervasyon/'+item.id);
    }
  },
  created() {
    this.isMobile = this.checkIsMobile();
    this.splitQuery(this.$route.query);
  }
}
</script>

<style lang="scss" scoped>
.va-avatar {
  border-radius: 0;
  height: auto;
  max-height: 30px;
}
.div--relative {
  position: relative;
  width: 100%;
  .btn--clear {
    position: absolute;
    top: 5px;
    right: 15px;
  }
}
.btn--wrapper {
  position: relative;
  margin-top: -1rem;
}
</style>